import { Component, ViewEncapsulation } from '@angular/core';
import { SaasService } from '../../utils/saas.service';

/**
 * Account Component, serves as a page wrapper for /account routes
 */
@Component({
  selector: 'account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AccountComponent {
  /**
   * Branding for the account pages depends on the host the app is served from,
   * as the user is not known yet at this point.
   */
  public readonly isSaasHost: boolean;
  public readonly logoSrc: string;
  public readonly logoAlt: string;

  /**
   * @constructor
   */
  constructor(private saasService: SaasService) {
    this.isSaasHost = this.saasService.isSaasHost;
    this.logoSrc = this.isSaasHost
      ? SaasService.ENGYNN_LOGO_URL
      : 'assets/images/web_topbar_logo.png';
    this.logoAlt = this.isSaasHost ? 'Engynn' : 'Engineius';
  }

  /**
   * Returns true if is considered desktop width?
   * todo: check usages and refactor out
   */
  isDesktop() {
    return window.innerWidth > 1024;
  }
}
